var map = {
	"./banner1.jpg": "bvHn",
	"./banner2.jpg": "YdqA",
	"./banner3.jpg": "Irxm",
	"./banner435.jpg": "tkvS",
	"./banner_bg1.png": "dDUI",
	"./banner_bg12.jpg": "WY58",
	"./banner_bg2.jpg": "CA82",
	"./banner_bg3.jpg": "kCW2",
	"./banner_bg4.jpg": "7m7c",
	"./banner_bg5.jpg": "dJIO",
	"./footer_bg.png": "7LeT",
	"./logo.png": "QQ3S",
	"./navigation_m.png": "klhf",
	"./news_bg.png": "fqCW",
	"./partner_I.png": "xVEd",
	"./partner_II.png": "Ncmy",
	"./partner_III.png": "//Il",
	"./partner_IV.png": "06rZ",
	"./partner_IX.png": "o6eK",
	"./partner_V.png": "A29R",
	"./partner_VI.png": "8Sq0",
	"./partner_VII.png": "Cp0H",
	"./partner_VIII.png": "POId",
	"./partner_X.png": "cvv7",
	"./partner_XI.png": "o2pD",
	"./partner_XII.png": "NleD",
	"./partner_XIII.png": "Ovbg",
	"./partner_XIV.png": "JWlS",
	"./partner_XIX.png": "CH/N",
	"./partner_XV.png": "eLFX",
	"./partner_XVI.png": "0zq7",
	"./partner_XVII.png": "kNN6",
	"./partner_XVIII.png": "5MhY",
	"./partner_XX.png": "xuD7",
	"./partner_XXI.png": "581a",
	"./partner_XXII.png": "Acfg",
	"./partner_XXIII.png": "cD84",
	"./partner_XXIV.png": "rswd",
	"./partner_bg.png": "BdFz",
	"./product_icon_m.png": "zqt7",
	"./search_m.png": "RSNW",
	"./solution1.jpg": "tL20",
	"./solution2.jpg": "sUm/",
	"./solution3.jpg": "hjmI",
	"./solution4.jpg": "hdTl",
	"./solution5.jpg": "mZOr",
	"./synopsis_bg.png": "269c",
	"./synopsis_certificate.png": "AFgV",
	"./synopsis_enterprise.png": "QIXw",
	"./synopsis_innovate.png": "cifp",
	"./synopsis_success.png": "he6/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gSML";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home ^\.\/.*$
// module id = gSML
// module chunks = 9